// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25P9I","title":"styles_title__1iFon"};